import { Modal as ModalModule, UI, Utils } from 'common';
import React, { useContext, useState } from 'react';
import AccountCommunication from '../utils/AccountCommunication';

const { WrappedDropdownWithLabel } = UI;
const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const RegionsModal = ({
	data: { callback, regions, selectedLocations },
	modalId,
}) => {
	const { closeModal, showError } = useContext(ModalContext);

	// disables Update button
	const [isUpdating, setIsUpdating] = useState(false);

	// locations
	const [locations, setLocations] = useState([...selectedLocations]);

	/**
	 * Make API call to update the locations
	 */
	const updateLocations = async () => {
		setIsUpdating(true);

		const response = await AccountCommunication.updateLocations(locations);

		setIsUpdating(false);

		if (!AccountCommunication.isSuccessful(response)) {
			showError({
				response,
			});
		} else {
			closeModal(modalId);
		}

		callback(response);
	};

	/**
	 * Return true if the passed in property matches for all locations
	 */
	const locationsPropertyMatch = property => {
		let propertyValue;

		selectedLocations.forEach((loc, index) => {
			if (index === 0) {
				propertyValue = loc.MeterAccount[property];
			} else if (loc.MeterAccount[property] !== propertyValue) {
				return false;
			}
		});

		return true;
	};

	const [corpId, setCorpId] = useState(
		locationsPropertyMatch('CorpId')
			? selectedLocations[0].MeterAccount.CorpId
			: null
	);

	const updateLocationsProperty = (propertyName, value) => {
		const updatedLocations = [...locations];

		updatedLocations.forEach((loc, index) => {
			updatedLocations[index].MeterAccount[propertyName] = value;
		});

		setLocations(updatedLocations);
	};

	const onUpdateLocationsButtonClick = () => {
		// if region changed, update all selected locations
		if (corpId !== null) {
			updateLocationsProperty('CorpId', corpId);
		}

		// update locations
		updateLocations();
	};

	return (
		<Modal
			modalId={modalId}
			className="account-locations regions-modal"
			header={`Bulk Update ${locations.length} Locations`}
			primaryButton={{
				type: ModalButtonActionType.Ok,
				onClick: onUpdateLocationsButtonClick,
				text: 'Update Locations',
				disabled: isUpdating,
			}}
			secondaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Close',
			}}
			size="small"
		>
			<div className="body">
				<div className="p-grid">
					<WrappedDropdownWithLabel
						className="dropdown p-col-12"
						label="Region"
						uiElementConfig={{
							name: 'corpId',
							value: corpId,
							options: regions,
							optionLabel: 'Name',
							optionValue: 'Id',
							placeholder: 'Select a Region',
							dataqa: 'locationbulkeditregion',
							onChange: e => {
								setCorpId(e.target.value);
							},
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default RegionsModal;
